import { urlApi } from "../config/Constantes";
import BaseService from "./geral/BaseService";

const base = "Acesso";

export default class UserService extends BaseService {
    constructor() {
        super(base);
    }

    AlterarSenha = (senha, novasenha) => {
        return super.httpPost(`/${base}/AlterarSenha?senhaAtual=${senha}&novaSenha=${novasenha}`);
    }

    AlterarCelular = (ddd, celular) => {
        const dddStr = String(ddd !== undefined && ddd !== null ? ddd : '');
        const celularStr = String(celular !== undefined && celular !== null ? celular : '');
        return super.httpPost(`/${base}/AlterarCelular?ddd=${dddStr}&celular=${celularStr}`);
    };

    AlterarSenhaAnonimo = (usuario, senha, novasenha) => {

        return fetch(`${urlApi}/${base}/AlterarSenhaAnonyous?usuario=${usuario}&senhaAtual=${senha}&novaSenha=${novasenha}`, {
            method: 'POST'
        });
    }
    
    RecuperarSenha = (email) => {
        return super.httpPost(`/${base}/RecuperarSenha?emailUsuario=${email}`, email, false);
    }

    menusUsuario = () => {
        return super.httpGet(`/${base}/listar-menu`);
    }

    listarAcl = () => {
        return this.httpGet(`/${base}/listar-permissao`);
    }
}


// WEBPACK FOOTER //
// ./src/services/UserService.js